import BaseInstance from "../base.instance";
import {
  ATTENDANCE_LIST,
  ATTENDANCE_FORCE_UPDATE,
  RECAPITULATION_LIST,
  ATTENDANCE_REQUEST_UPDATE,
  ATTENDANCE_REQUEST_UPDATE_LIST,
  ATTENDANCE_REQUEST_UPDATE_BULK,
  ATTENDANCE_REQUEST_UPDATE_STATUS,
  ATTENDANCE_REQUEST_UPDATE_DELETE,
  ATTENDANCE_REQUEST_OFF,
  ATTENDANCE_REQUEST_OFF_LIST,
  ATTENDANCE_REQUEST_OFF_BULK,
  ATTENDANCE_REQUEST_OFF_STATUS,
  ATTENDANCE_REQUEST_OFF_DELETE
} from "../constants";

const AttendanceService = {
  getList(data) {
    return BaseInstance.post(ATTENDANCE_LIST, data);
  },
  forceUpdate(data) {
    return BaseInstance.post(ATTENDANCE_FORCE_UPDATE, data);
  },
  recapitulationList(data) {
    return BaseInstance.post(RECAPITULATION_LIST, data);
  },
  // Request Update
  getListRequestUpdate(data) {
    return BaseInstance.post(ATTENDANCE_REQUEST_UPDATE_LIST, data);
  },
  saveRequestUpdate(data) {
    return BaseInstance.post(ATTENDANCE_REQUEST_UPDATE, data);
  },
  saveBulkRequestUpdate(data) {
    return BaseInstance.post(ATTENDANCE_REQUEST_UPDATE_BULK, data);
  },
  detailRequestUpdate(id) {
    return BaseInstance.fetch(ATTENDANCE_REQUEST_UPDATE, id);
  },
  updateStatusRequestUpdate(data) {
    return BaseInstance.post(ATTENDANCE_REQUEST_UPDATE_STATUS, data);
  },
  deleteRequestUpdate(data) {
    return BaseInstance.post(ATTENDANCE_REQUEST_UPDATE_DELETE, data);
  },
  // Request Off
  getListRequestOff(data) {
    return BaseInstance.post(ATTENDANCE_REQUEST_OFF_LIST, data);
  },
  saveRequestOff(data) {
    return BaseInstance.post(ATTENDANCE_REQUEST_OFF, data);
  },
  saveBulkRequestOff(data) {
    return BaseInstance.post(ATTENDANCE_REQUEST_OFF_BULK, data);
  },
  detailRequestOff(id) {
    return BaseInstance.fetch(ATTENDANCE_REQUEST_OFF, id);
  },
  updateStatusRequestOff(data) {
    return BaseInstance.post(ATTENDANCE_REQUEST_OFF_STATUS, data);
  },
  deleteRequestOff(data) {
    return BaseInstance.post(ATTENDANCE_REQUEST_OFF_DELETE, data);
  }
};

export default AttendanceService;
